export default "__VITE_ASSET__00377cc0__"